import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AccessToken {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  jti: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private router: Router) { }


  login(usuario: string, clave: string): Observable<AccessToken> {

    let body = `grant_type=password&username=${encodeURIComponent(usuario)}&password=${encodeURIComponent(clave)}`;

    return this.http.post<AccessToken>(`${environment.host}/oauth/token`, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
        .set('Authorization', 'Basic ' + btoa(environment.tokenClientId + ':' + environment.tokenClientSecret))
    });
  }

  /**
   * Limpia TODA la sesión: sessionStorage, localStorage y navega al login.
   * Se llama desde navbar, verificacion, y auth-interceptor (401).
   */
  logout(): void {
    // 1. Limpiar almacenamiento del navegador
    sessionStorage.clear();
    localStorage.clear();

    // 2. Navegar al login (notación correcta con paréntesis)
    this.router.navigate(['/login']);
  }
}
